import {FCWithHTMLAttributes} from "../../types/reactTypes";
import Line from "./Line";

/**
 * Overline text element with the small orange line decoration.
 */
const OverlineWithLine: FCWithHTMLAttributes<{overline?: string}> = ({
	overline,
	className,
}) =>
	overline && (
		<div className={`flex items-center gap-3 ${className}`}>
			<Line />
			<span className="font-overline">{overline}</span>
		</div>
	);

export default OverlineWithLine;
